// extracted by mini-css-extract-plugin
module.exports = {"headshot":"_b6275546","image":"_99699549"};